import { Menu } from "antd";
import { useContext, useEffect, useState } from "react";
import { MyContext } from "../../component/utils/utils";
import styles from "./menu.module.css";
import User from "../User/user";

const MenuBar = ({}) => {
  const { current, setCurrent } = useContext(MyContext);
  const handleClick = (e) => {
    setCurrent(e.key);
  };
  return (
    <div className={styles.menu}>
      <p className={styles.logo}>IAM Card</p>
      <User />
    </div>
  );
};

export default MenuBar;
